import * as classnames from "classnames";

import { Msg } from "@shared/components";

export const ExamEnvironmentPanel = () => {
  const rootStyle = classnames("code-exam-environment-panel");

  return (
    <div className={rootStyle}>
      <div className="code-exam-environment-panel__container">
        <div className="panel-image1" />
        <div className="panel-image2" />
      </div>
      <ul className="code-exam-environment-panel__list">
        <li>
          <Msg id="start-challenge.note.internetConnection" />
        </li>
        <li>
          <Msg id="start-challenge.note.browserSupport" />
        </li>
      </ul>
    </div>
  );
};
